/**
 * Retorna uma saudação baseada no horário local atual.
 *
 * - 04:00 às 11:59: Bom dia
 * - 12:00 às 17:59: Boa tarde
 * - 18:00 às 03:59: Boa noite
 *
 * @returns {string} "Bom dia", "Boa tarde" ou "Boa noite"
 */
export function saudacao(): string {
    const horaAtual = new Date().getHours();

    if (horaAtual >= 4 && horaAtual < 12) {
        return "Bom dia";
    } else if (horaAtual >= 12 && horaAtual < 18) {
        return "Boa tarde";
    } else {
        return "Boa noite";
    }
}

// Exemplo de uso:
// console.log(saudacao());
// Se executado às 14h, a saída será: "Boa tarde"
